import { render } from "./ConfigPlantDashboards.vue?vue&type=template&id=1d39973a"
import script from "./ConfigPlantDashboards.vue?vue&type=script&lang=js"
export * from "./ConfigPlantDashboards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__